import React from "react";
import "./StoneSection.css";
import stoneVideo from "../Assets/videos/flower.mp4"; // replace with your actual video path
import { useNavigate } from "react-router-dom";

const StoneSection = () => {
  const navigate= useNavigate();
  return (
    <section className="stone-section">

      <div className="stone-text">
        <h1>
          We didn't <br />
          just build a business. <br />
          We built hope
        </h1>
        <button className="explore-btn" onClick={() => {navigate("/aboutVCNR"); window.scrollTo(0, 0);}}>About Us</button>
      </div>
      
      <video
        className="stone-video"
        src={stoneVideo}
        autoPlay
        muted
        loop
        playsInline
      ></video>

      
    </section>
  );
};

export default StoneSection;
